import { render, staticRenderFns } from "./SvgAnnotator.vue?vue&type=template&id=7da5f1a4&scoped=true&"
import script from "./SvgAnnotator.vue?vue&type=script&lang=js&"
export * from "./SvgAnnotator.vue?vue&type=script&lang=js&"
import style0 from "./SvgAnnotator.vue?vue&type=style&index=0&id=7da5f1a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da5f1a4",
  null
  
)

export default component.exports